export function buildPropertiesPageURL() {
  return '/properties'
}
